module.exports = __webpack_public_path__ + "media/alaska/small_seals-7d9837c4.jpg";